import React from 'react';
import { colors } from 'ui_system/compass/utils';

export const ThreeBars = (props) => {
  const { fill = colors.text.icon } = props;
  return (
    <svg
      height="512px"
      role="img"
      version="1.1"
      viewBox="0 0 512 512"
      width="512px"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <title>three-bars</title>
      <g transform="scale(1,-1) translate(0 -512)">
        <path
          d="M64 416l0-64 384 0 0 64z m0-192l384 0 0 64-384 0z m0-128l384 0 0 64-384 0z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
